export class EditSubTopicPayload {
  discussion: string;
  notes: string;
  topicName?: string;
  topicId: number;
}
